import { SensorListItem } from "@shared/models";
import { call, put, takeLatest } from "redux-saga/effects";
import { PaginatedResponse, ActionWithPayload, UpdateStatusShape, SensorFilter } from "@shared/interfaces";
import { startLoading, stopLoading } from "@shared/store/actions";

import api from "../api";
import { CreateSensorDto, CreateSensorSuccess } from "../interfaces";
import { createSensor, getSensors, updateSensor, updateSensorStatus } from "./actions";

function* getSensorsSaga({ payload }: ActionWithPayload<SensorFilter>) {
  try {
    yield put(startLoading());
    const response: PaginatedResponse<SensorListItem> = yield call(api.getSensors, payload);
    yield put(stopLoading());
    yield put(
      getSensors.success({
        ...response,
        is_clear: !payload.page,
      }),
    );
  } catch (error) {
    yield put(getSensors.failure(error as Error));
    yield put(stopLoading());
  }
}

function* createSensorSaga({ payload }: ActionWithPayload<CreateSensorDto>) {
  try {
    yield put(startLoading());
    const response: CreateSensorSuccess = yield call(api.createSensor, payload);
    yield put(stopLoading());
    yield put(createSensor.success(response));
  } catch (error) {
    yield put(createSensor.failure(error as Error));
    yield put(stopLoading());
  }
}

function* updateSensorSaga({ payload }: ActionWithPayload<CreateSensorDto & { id: number }>) {
  try {
    yield put(startLoading());
    const response: CreateSensorSuccess = yield call(api.updateSensor, payload);
    yield put(stopLoading());
    yield put(updateSensor.success(response));
  } catch (error) {
    yield put(updateSensor.failure(error as Error));
    yield put(stopLoading());
  }
}

function* updateSensorStatusSaga({ payload }: ActionWithPayload<UpdateStatusShape>) {
  try {
    yield put(startLoading());
    const response: CreateSensorSuccess = yield call(api.updateSensorStatus, payload);
    yield put(stopLoading());
    yield put(updateSensorStatus.success(response));
  } catch (error) {
    yield put(updateSensorStatus.failure(error as Error));
    yield put(stopLoading());
  }
}

function* userSagas() {
  yield takeLatest(getSensors.request, getSensorsSaga);
  yield takeLatest(createSensor.request, createSensorSaga);
  yield takeLatest(updateSensor.request, updateSensorSaga);
  yield takeLatest(updateSensorStatus.request, updateSensorStatusSaga);
}

export default userSagas;
